import React, {Component} from 'react';
import axios from "axios";

function logout() {
  axios.get(localStorage.getItem('host') + '/auth/deletelogin/'+localStorage.getItem('refId'), {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    } 
  }).then(
    res => {
    localStorage.clear();
    window.location.href = "/"
    }, err => {
      console.log("....."+err)
      localStorage.clear();
      window.location.href = "/"
  }
)
}

export default class Top extends Component {
    
     state = { sidebarToggled: window.screen.width > 767, showLogin: true, showNav: true, showDropDown: false, count: 0, notifications: [], showSubmit: false, username: '', usernameError: '', password: '', passwordError: '', error: '', ipAddress: '', country: '', time: new Date().toTimeString().slice(0,8),
    userId: localStorage.getItem('userId'), admin: localStorage.getItem('admin'), refId: localStorage.getItem('refId'), companyId: localStorage.getItem('companyId'), speciality: localStorage.getItem('speciality'), roleId: localStorage.getItem('roleId'), companyName: localStorage.getItem('companyName') };

        sidebarToggle()
         {

    if(!this.state.sidebarToggled){
      document.getElementById("page-content-wrapper").style.marginLeft = "0rem";
document.getElementById("sidebar-wrapper").style.marginLeft = "0rem";
}
else {
document.getElementById("page-content-wrapper").style.marginLeft = "0rem";
document.getElementById("sidebar-wrapper").style.marginLeft = "-15rem";
}
            console.log('sidebarToggled'+!this.state.sidebarToggled)
            this.setState({sidebarToggled: !this.state.sidebarToggled})
         }
      render() {
        return (

<nav className="navbar navbar-expand-lg border-bottom" style={{ backgroundColor: '#e3f2fd', borderColor: '#08285F' }}>
                <div className="container-fluid">
                    <button className="btn btn-primary" id="sidebarToggle" style={{ backgroundColor: '#36BEEE' }}  onClick={() => { this.sidebarToggle() }}>{this.state.sidebarToggled? <i className="bi bi-list"></i>:<i class="bi bi-list-nested"></i>}</button>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" onClick={() => { this.toggleNav() }} aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
                    <div className={(this.state.showNav ? 'show' : '') + ' collapse navbar-collapse'}>
                        <ul className="navbar-nav ms-auto mt-2 mt-lg-0">
                            <li className="nav-item nav-black" ><i className="bi bi-clock i"></i><span id="digiclock"></span>{this.state.time}</li>
                            <li className="nav-item nav-black"  ><i className="bi bi-building i"></i><span >{localStorage.getItem('companyName')}</span> </li>
                            <li className="nav-item nav-black"  ><i className="bi bi-person-circle i"></i><span >{localStorage.getItem('fullname')}</span> </li>
                            <li className="nav-item" ><span className="navLinkColor" title="Change Role Company" onClick={() => this.openUserRoleCompany()}><i className="bi bi-box-arrow-in-down-right"></i></span></li>
                            <li className="nav-item"  ><span className="navLinkColor" title="Change Password" onClick={() => this.changePassword()} ><i className="bi bi-lock-fill"></i></span></li>
                            <li className="nav-item dropdown" >
                                <a className="navLinkBell" id="navbarDropdown" href={() => false} onClick={() => { this.toggleDropDown() }}><i className="bi bi-bell-fill i"></i>
                                    <span className="top-0 translate-middle badge rounded-pill bg-danger">{this.state.count}</span>
                                </a>
                            </li>
                            <li className="nav-item"  ><span onClick={() => { logout(); }} className="navLinkColor" title="Logout"><i className="bi bi-box-arrow-right"></i></span></li>

                        </ul>
                    </div>
                </div>
            </nav>

        )}
    }